import { Theme, createTheme } from "@mui/material/styles";

import { darkTheme, lightTheme } from "@themes";

const commonTheme = (theme: Theme) => ({
  footerBackgroundGradient:
    "radial-gradient(44.06% 50% at 50% 0%, rgba(5, 223, 84, 0.08) 0%, rgba(150, 197, 240, 0.04) 100%)",
});

export const agileDarkTheme = createTheme(darkTheme, commonTheme(darkTheme));
export const agileLightTheme = createTheme(lightTheme, commonTheme(lightTheme));
